import { observer } from "mobx-react";
import React, { useContext } from "react";
import { OfferOptionsContext } from "@gp/components";

export default observer(function TopEventTag(props: {
	className: string;
	event: { isTopEvent?: boolean };
}) {
	const options = useContext(OfferOptionsContext);

	// @ts-expect-error
	if (options.shouldHideTopTag || !props.event.isTopEvent) {
		return null;
	}

	return <i className={props.className} />;
});
